var List = require("../collections/list.js");
var SortedMap = require("../collections/sortedMap.js");
var inherit = require("../general.js").inherit;
var sanityCheckHandler = require("./sanityCheckHandler.js");

var ObservableList = function(validator){
    List.call(this);

    if (typeof validator == "function") this.validator = validator;

    this.handlers = {
        add: null,
        put: null,
        addFail: null,
        remove: null
    };
};
inherit(ObservableList, List);

ObservableList.prototype.getType = function(){return "list"};

ObservableList.prototype.add = function(idx, val){
    var self = this;
    if (idx < 0) idx = this.size() + idx;
    if (idx >= 0 && idx <= this.size()){
        var validated = !this.validator || this.validator(idx, val);
        if(validated) {
            List.prototype.add.call(this, idx, val);
            this.handlers.add && this.handlers.add.forEach(function(k, handler){
                handler.call(self, idx, val);
            });
        } else {
            this.handlers.addFail && this.handlers.addFail.forEach(function(k, handler){
                handler.call(self, idx, val);
            });
        }
        return validated;
    }
};

ObservableList.prototype.put = function(idx, val){
    var self = this;
    if (idx < 0) idx = this.size() + idx;
    var oldVal = this.get(idx);
    if (idx >= 0 && idx <= this.size() && oldVal !== val) {
        var validated = !this.validator || this.validator(idx, val, oldVal);
        if (validated) {
            List.prototype.put.call(this, idx, val);
            this.handlers.put && this.handlers.put.forEach(function(k, handler) {    // TODO: put at the end of list should call onAdd handlers!
                handler.call(self, idx, val, oldVal);
            });
        } else {
            this.handlers.addFail && this.handlers.addFail.forEach(function(k, handler) {
                handler.call(self, idx, val, oldVal);
            });
        }
        return validated;
    } else return true; // TODO: put on invalid index should return false
};

ObservableList.prototype.remove = function(idx) {
    var self = this;
    if (idx < 0) idx = this.size() + idx;
    if (this.hasIndex(idx)) {
        var val = List.prototype.remove.call(this, idx);
        this.handlers.remove && this.handlers.remove.forEach(function(k, handler){
            handler.call(self, idx, val);
        });
        return val;
    }
};

ObservableList.prototype.onAdd = function(key, handler, priority) {  // handlers without priority get default priority 0 and are sorted in insertion order
    sanityCheckHandler(arguments);
    if(!this.handlers.add) this.handlers.add = new SortedMap();
    this.handlers.add.put(key, handler, priority || 0);
};

ObservableList.prototype.onPut = function(key, handler, priority) {
    sanityCheckHandler(arguments);
    if(!this.handlers.put) this.handlers.put = new SortedMap();
    this.handlers.put.put(key, handler, priority || 0);
};

ObservableList.prototype.onAddFail = function(key, handler, priority) {
    sanityCheckHandler(arguments);
    if(!this.handlers.addFail) this.handlers.addFail = new SortedMap();
    this.handlers.addFail.put(key, handler, priority || 0);
};

ObservableList.prototype.onRemove = function(key, handler, priority) {
    sanityCheckHandler(arguments);
    if(!this.handlers.remove) this.handlers.remove = new SortedMap();
    this.handlers.remove.put(key, handler, priority || 0);
};

ObservableList.prototype.removeHandlers = function(key){
    for (var type in this.handlers){
        if(this.handlers[type]) {
            this.handlers[type].remove(key);
            this._cleanHandlers(type);
        }
    }
};

ObservableList.prototype.removeAllHandlers = function(col){
    for (var type in this.handlers) {
        if(this.handlers[type]) {
            this.handlers[type].removeAll(col);
            this._cleanHandlers(type);
        }
    }
};

ObservableList.prototype.removeHandlersWhere = function(f){
    for (var type in this.handlers){
        if(this.handlers[type]) {
            this.handlers[type].removeWhere(f);
            this._cleanHandlers(type);
        }
    }
};

ObservableList.prototype._cleanHandlers = function(type) {
    if(this.handlers[type].size() == 0)
        this.handlers[type] = null;
};

module.exports = ObservableList;